/* eslint-disable react/no-danger */
import React from "react";
import { Card, CardBody, Badge } from "reactstrap";
import { Colxx } from "../common/CustomBootstrap";
import { useTranslation } from "react-i18next";

const SurveyDetailCard = ({ user }) => {
  const { t } = useTranslation();
  return (
    <>
      {" "}
      <p className="list-item-heading mb-4">
        <strong>{t("candidateDetails")}</strong>
      </p>
      <p className="text-muted text-small mb-2">
        <strong>{t("fullName")}</strong>
      </p>
      <p className="mb-3">
        {user?.firstName} {user?.lastName}
      </p>
      <p className="text-muted text-small mb-2">
        <strong>{t("phoneNumber")}</strong>
      </p>
      <p className="mb-3">{user?.phone}</p>
      <p className="text-muted text-small mb-2">
        <strong>{t("email")}</strong>
      </p>
      <p className="mb-3">{user?.email}</p>
    </>
  );
};

export default React.memo(SurveyDetailCard);
